import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if ((window as any).environment === 'test' || (window as any).environment === 'prod') {
  enableProdMode();
}


if (document.getElementsByTagName('base')[0].href.includes('?showMobile=true') && window.location.href.includes('?showMobile=true')) {
  /* Remove returning mobile user's showMobile Flag from the baseUrl */

  // remove showMobile flag from index's baseUrl
  document.getElementsByTagName('base')[0].href = document.getElementsByTagName('base')[0].href.replace('?showMobile=true', '');

} else if (document.getElementsByTagName('base')[0].href.includes('?showMobile=true')) {
  /* reroute mobiles user's first visit */

  // remove showMobile flag from index's baseUrl
  document.getElementsByTagName('base')[0].href = document.getElementsByTagName('base')[0].href.replace('?showMobile=true', '');
  // reroute mobile users directly to map page, with showMobile flag in the URL
  const mobileRerouteUrl: string = document.getElementsByTagName('base')[0].href + 'mobile-home?showMobile=true';
  window.location.replace(mobileRerouteUrl);
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
